// extracted by mini-css-extract-plugin
export default {"mediaSwiper":"Media-module__mediaSwiper--AP0z","image":"Media-module__image--aKdr"};